export const ProductForm = {
  model: 'Product',
  format: [
    {
      widths: 'equal',
      fields: {
        commodity: {
          required: true,
          type: 'dropdown search',
          url: '/main/commodities/',
          label: 'Select or Create Commodity',
          title_fields: ['name'],
          url_params: ['commodity_id'],
          filter_field: 'name__icontains',
          allow_add: true,
          description_fields: [],
          model: 'Commodity',
          model_form: 'CommodityForm',
        },
        commodity_form: {
          required: true,
          type: 'dropdown search',
          url: '/main/commodity-forms/',
          label: 'Select or Create Commodity Form',
          title_fields: ['name'],
          url_params: ['commodity_form_id'],
          filter_field: 'name__icontains',
          allow_add: true,
          allow_add_related_params: {
            commodity: 'commodity_id',
          },
          // This says: require all 'related_params' in order to display values
          require_params: true,
          // this says: pass in the current buyer field (above field) as "buyer_id" into the dropdown search
          related_params: {
            commodity: 'commodity_id',
          },
          description_fields: [],
          model: 'CommodityForm',
          model_form: 'CommodityFormForm',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        material: {
          required: true,
          type: 'dropdown search',
          url: '/main/materials/',
          label: 'Select or Create Material',
          title_fields: ['name'],
          filter_field: 'name__icontains',
          allow_add: true,
          description_fields: [],
          model: 'Material',
          model_form: 'MaterialForm',
        },
        default_unit_of_measure: {
          type: 'dropdown search',
          url: '/main/unit-of-measures/',
          label: 'Select Default Unit of Measures',
          option_text_fields: ['plural_name'],
          title_fields: ['plural_name'],
          allow_add: true,
          description_fields: [],
          model: 'UnitOfMeasure',
          model_form: 'UnitOfMeasureForm',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        allowed_units_of_measure: {
          type: 'multiple dropdown model',
          url: '/main/unit-of-measures/',
          label: 'Select Allowed Unit of Measure',
          option_text_fields: ['plural_name'],
          title_fields: ['plural_name'],
          allow_add: true,
          description_fields: [],
          model: 'UnitOfMeasure',
          model_form: 'UnitOfMeasureForm',
        },
      },
    },
  ],
}
